<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <em>
            <p>
                W odpowiedzi na ogromne zainteresowanie i liczne listy intencyjne dotyczące współpracy w ramach Centrów Kompetencji, Polska
                Agencja Żeglugi Powietrznej zdecydowała się na utrzymanie formuły 10 Centrów Kompetencji, rozlokowanych w ramach pięciu
                zaktualizowanych obszarów geograficznych.
            </p>
            <p>
                Wysokie zaangażowanie ze strony uczestników Konkursu potwierdza, że zaproponowana struktura odpowiada obecnie najlepiej
                realnym potrzebom rynku i otwiera nowe możliwości rozwoju. Dzięki tak dużej aktywności partnerów potencjał rynku
                bezzałogowych statków powietrznych (BSP) zostanie rozwinięty w stopniu możliwie maksymalnym, wspierając jego dynamiczny
                rozwój i innowacyjność. Dokładnie taki jest cel Konkursu.
            </p>
            <p>
                Stworzenie 10 CK w ramach pięciu obszarów geograficznych spowoduje realne zwiększenie dostępu do najlepszych praktyk i
                wiedzy branżowej. Wspólnie z partnerami stworzymy przestrzeń dla szerokiego udziału społeczeństwa w rozwoju sektora BSP i
                zapewniamy efektywne wykorzystanie funduszy europejskich w oparciu o aktualne dane i analizy.
            </p>
            <p>
                Naszą misją jest wykreowanie racjonalnych warunków do tego, aby najwięcej Polek i Polaków mogło skorzystać z możliwości,
                jakie niesie ze sobą rozwój technologii dronowych – zarówno w wymiarze gospodarczym, jak i społecznym.
            </p>
            <br />
            <p>
                Mając na uwadze treść § 10 ust. 1 i 2 regulaminu Konkursu do naboru podmiotów do współpracy przy wdrożeniu usługi w ramach
                projektu "Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra
                monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych jako ekosystem innowacji" (dalej:
                "Regulamin"), postanawia się co następuje:
            </p>
        </em>
        <ol class="outer-list">
            <li>
                Regulamin ulega zmianie w ten sposób, że:
                <em>
                    <ol class="inner-list">
                        <li>
                            § 6 ust. 2 otrzymuje brzmienie:
                            <br />
                            <em>2. Konkurs prowadzony będzie w okresie od 19.03.2025 r. do 05.09.2025 r.</em>
                        </li>
                        <li>
                            6 ust. 5 otrzymuje brzmienie:
                            <br />
                            <em>
                                5. Etap II Konkursu, w ramach którego nastąpi ocena Wniosków i wybór Uczestników do współpracy przy
                                wdrożeniu Usługi, przeprowadzony będzie od 01.04.2025 r. do 05.09.2025 r. Termin składania Wniosków ustala
                                się od 01.04.2025 r. do 11.08.2025 r. (<strong>"Etap II"</strong>). Ogłoszenie wyniku Etapu II nastąpi do
                                dnia 05.09.2025r. na stronie Krajowego Systemu Informacji Dronowej (<a
                                    href="https://drony.gov.pl"
                                    target="_blank"
                                    rel="noopener norefer"
                                    >https://drony.gov.pl</a
                                >).
                            </em>
                        </li>
                        <li>
                            § 8 ust. 11 otrzymuje brzmienie:
                            <br />
                            <em>
                                11. Analiza i ocena wszystkich Wniosków złożonych w ramach Etapu II nastąpi najpóźniej do dnia
                                <strong>05.09.2025</strong>
                                r., przy czym okres ten może ulec przedłużeniu jeżeli będzie to uzasadnione i niezbędne dla prawidłowej
                                analizy i oceny Wniosków. Informacja o przedłużeniu terminu analizy i oceny Wniosków zostanie przekazana
                                Uczestnikom na adresy e-mail wskazane we Wnioskach.
                            </em>
                        </li>
                        <li>
                            9 ust. 1 otrzymuje brzmienie:
                            <br />
                            <em>
                                <div class="pseudo-list-item">
                                    <span>1.</span>
                                    <div>
                                        Na podstawie przeprowadzonej analizy i oceny wszystkich Wniosków złożonych w ramach Etapu II KOW
                                        dokona wyboru nie więcej niż 9 (dziewięciu) Uczestników (Laureatów) do utworzenia CK i wdrożenia
                                        Usługi według poniższych zasad:
                                        <ol class="inner-list">
                                            <li>
                                                pierwszymi 5 (pięcioma) Laureatami zostaną Uczestnicy Konkursu, których Lokalizacje zdobędą
                                                największą liczę punktów w ramach jednego z pięciu obszarów:
                                                <ol class="alpha-list">
                                                    <li>
                                                        obszar 1 – województwa pomorskie, warmińsko-mazurskie, podlaskie oraz lubelskie,
                                                    </li>
                                                    <li>obszar 2 – województwa podkarpackie, małopolskie oraz świętokrzyskie,</li>
                                                    <li>
                                                        obszar 3 – województwa wielkopolskie, lubuskie, zachodniopomorskie oraz
                                                        kujawsko-pomorskie,
                                                    </li>
                                                    <li>obszar 4 – województwa śląskie, opolskie i dolnośląskie,</li>
                                                    <li>obszar 5 – województwa mazowieckie oraz łódzkie.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                kolejnymi 4 (czterema) Laureatami Konkursu zostaną Uczestnicy, których Lokalizacje uzyskały
                                                największą liczbę punktów, spośród pozostałych Uczestników, którzy nie zostali Laureatami w
                                                wyniku weryfikacji opisanej w punkcie b) powyżej,
                                            </li>
                                            <li>
                                                jeżeli w którymś z obszarów, wskazanych w ppkt 1 powyżej, nie został wyłoniony żaden Laureat
                                                (np. w wyniku braku zgłoszonych Lokalizacji), to automatycznie zwiększa się liczba Laureatów
                                                Konkursu wyłanianych zgodnie z zasadami określonymi w ppkt 2 powyżej.
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </em>
                        </li>
                    </ol>
                </em>
            </li>
            <li>
                Ustala się tekst jednolity Regulaminu oraz zarządza jego niezwłoczną publikację pod adresem:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">https://drony.gov.pl</a>.
            </li>
            <li>
                Zmiany Regulaminu, o których mowa w pkt. 1 ppkt. 1-3 powyżej uzasadnione są koniecznością przeprowadzenia procedury
                wyjaśnienia/uzupełnienia niemal wszystkich Wniosków złożonych w II Etapie Konkursu.
                <br />
                <br />
                Zmiana, o której mowa w pkt. 1 ppkt. 4 powyżej uzasadniona jest wysokim zaangażowaniem ze strony uczestników Konkursu, które
                potwierdza, że zaproponowana struktura odpowiada obecnie najlepiej realnym potrzebom rynku i otwiera nowe możliwości
                rozwoju. Dzięki tak dużej aktywności partnerów potencjał rynku bezzałogowych statków powietrznych (BSP) zostanie rozwinięty
                w stopniu możliwie maksymalnym, wspierając jego dynamiczny rozwój i innowacyjność. Dokładnie taki jest cel Konkursu.
                <br />
                <br />
                Stworzenie 10 CK w ramach pięciu obszarów spowoduje realne zwiększenie dostępu do najlepszych praktyk i wiedzy branżowej.
                Wspólnie z partnerami stworzymy przestrzeń dla szerokiego udziału społeczeństwa w rozwoju sektora BSP i zapewniamy efektywne
                wykorzystanie funduszy europejskich w oparciu o aktualne dane i analizy.
            </li>
            <li>Zmiana Regulaminu wchodzi w życie z dniem 25 sierpnia 2025 r.</li>
        </ol>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <em>
            <p>
                In response to the significant interest and numerous letters of intent regarding cooperation within the Competence Centres,
                PANSA has decided to maintain the concept of 10 Competence Centres located within five updated geographical areas.
            </p>
            <p>
                The high level of engagement from Competition Participants confirms that the proposed structure currently best addresses the
                real needs of the market and opens new development opportunities. Thanks to such strong partner activity, the potential of
                the unmanned aerial vehicle (UAV) market will be developed to the maximum possible extent, supporting its dynamic growth and
                innovation. This is exactly the aim of the Competition.
            </p>
            <p>
                Creating 10 Competence Centres within five geographical areas will result in a tangible increase in access to best practices
                and industry knowledge. Together with partners we will create space for broad public participation in the development of the
                UAV sector and ensure the effective use of European funds based on current data and analyses.
            </p>
            <p>
                Our mission is to create rational conditions so that as many people in Poland as possible can benefit from the opportunities
                brought by the development of drone technologies – both economically and socially.
            </p>
            <br />
            <p>
                Taking into account § 10 sections 1 and 2 of the Competition Rules for the recruitment of entities to cooperate in the
                implementation of the service under the project "Expansion and equipping of competence centers (specialized training
                centers, implementation support centers, monitoring centers) and infrastructure for unmanned vehicle traffic management as
                an innovation ecosystem" (hereinafter: the "Rules"), it is decided as follows:
            </p>
        </em>
        <ol class="outer-list">
            <li>
                The Rules are amended as follows:
                <em>
                    <ol class="inner-list">
                        <li>
                            § 6 section 2 is amended to read as follows:
                            <br />
                            <em>2. The Competition will be held from 19.03.2025 to 05.09.2025.</em>
                        </li>
                        <li>
                            § 6 section 5 is amended to read as follows:
                            <br />
                            <em>
                                5. Stage II of the Competition, during which Applications will be evaluated and Participants selected for
                                cooperation in the implementation of the Service, will be conducted from 01.04.2025 to 05.09.2025. The
                                Application submission period is from 01.04.2025 to 11.08.2025 (<strong>"Stage II"</strong>). The result of
                                Stage II will be announced by 05.09.2025 on the website of the National Drone Information System (<a
                                    href="https://drony.gov.pl"
                                    target="_blank"
                                    rel="noopener norefer"
                                    >https://drony.gov.pl</a
                                >).
                            </em>
                        </li>
                        <li>
                            § 8 section 11 is amended to read as follows:
                            <br />
                            <em>
                                11. The analysis and evaluation of all Applications submitted under Stage II will take place no later than
                                <strong>05.09.2025</strong>, although this period may be extended if justified and necessary for the proper
                                analysis and evaluation of Applications. Information about the extension will be sent to Participants to the
                                e-mail addresses indicated in the Applications.
                            </em>
                        </li>
                        <li>
                            § 9 section 1 is amended to read as follows:
                            <br />
                            <em>
                                <div class="pseudo-list-item">
                                    <span>1.</span>
                                    <div>
                                        Based on the analysis and evaluation of all Applications submitted under Stage II, KOW will select
                                        no more than 9 (nine) Participants (Laureates) to establish the Competence Centres and implement the
                                        Service according to the following rules:
                                        <ol class="inner-list">
                                            <li>
                                                the first 5 (five) Laureates will be Participants whose Locations receive the highest score
                                                within one of the five areas:
                                                <ol class="alpha-list">
                                                    <li>area 1 – pomorskie, warmińsko-mazurskie, podlaskie and lubelskie voivodeships,</li>
                                                    <li>area 2 – podkarpackie, małopolskie and świętokrzyskie voivodeships,</li>
                                                    <li>
                                                        area 3 – wielkopolskie, lubuskie, zachodniopomorskie and kujawsko-pomorskie
                                                        voivodeships,
                                                    </li>
                                                    <li>area 4 – śląskie, opolskie and dolnośląskie voivodeships,</li>
                                                    <li>area 5 – mazowieckie and łódzkie voivodeships.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                the next 4 (four) Laureates of the Competition will be Participants whose Locations achieved
                                                the highest number of points among the remaining Participants who did not become Laureates
                                                under the verification described in item b) above,
                                            </li>
                                            <li>
                                                if in any of the areas indicated in sub-item 1 above no Laureate is selected (e.g. due to a
                                                lack of submitted Locations), the number of Laureates selected according to the rules set
                                                out in sub-item 2 above is automatically increased.
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </em>
                        </li>
                    </ol>
                </em>
            </li>
            <li>
                The consolidated text of the Rules is established and its immediate publication at:
                <a href="https://drony.gov.pl" target="_blank" rel="noopener norefer">https://drony.gov.pl</a> is ordered.
            </li>
            <li>
                The amendments to the Rules referred to in item 1 sub-items 1–3 above are justified by the need to conduct clarification/
                supplementation procedures for almost all Applications submitted in Stage II of the Competition.
                <br />
                <br />
                The amendment referred to in item 1 sub-item 4 above is justified by the high level of engagement from Competition
                Participants, which confirms that the proposed structure currently best addresses real market needs and opens new
                development opportunities. Thanks to such strong partner activity, the potential of the unmanned aerial vehicle (UAV) market
                will be developed to the maximum possible extent, supporting its dynamic growth and innovation. This is exactly the aim of
                the Competition.
                <br />
                <br />
                Creating 10 Competence Centres within five areas will result in a tangible increase in access to best practices and industry
                knowledge. Together with partners we will create space for broad public participation in the development of the UAV sector
                and ensure the effective use of European funds based on current data and analyses.
            </li>
            <li>The amendment to the Rules enters into force on 25 August 2025.</li>
        </ol>
    </ng-container>
</ng-container>
